/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */
import { CURRENT_CLIENT_TEMPLATE_VAR } from '@core';
import { HttpClient } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import type {
  CreateDeviceAttributeDto,
  DeviceAttributesControllerCreateAttributePathParameters,
  DeviceAttributesControllerDeleteAttributePathParameters,
  DeviceAttributesControllerGetAttributesPathParameters,
  DeviceAttributesControllerUpdateAttributePathParameters,
  UpdateDeviceAttributeDto,
} from '../models';

@Injectable({ providedIn: 'root' })
export class DeviceAttributesService {
  private readonly http = inject(HttpClient);
  /**
   * @summary Retrieve all standard device attributes
   */

  getAttributes<TData = void>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
  }: DeviceAttributesControllerGetAttributesPathParameters): Observable<TData> {
    return this.http.get<TData>(`/devices/v1/clients/${clientId}/device-attributes`);
  }
  /**
   * @summary Create a new standard device attribute
   */

  createAttribute<TData = void>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR }: DeviceAttributesControllerCreateAttributePathParameters,
    createDeviceAttributeDto: CreateDeviceAttributeDto,
  ): Observable<TData> {
    return this.http.post<TData>(`/devices/v1/clients/${clientId}/device-attributes`, createDeviceAttributeDto);
  }
  /**
   * @summary Update a standard device attribute
   */

  updateAttribute<TData = void>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR, id }: DeviceAttributesControllerUpdateAttributePathParameters,
    updateDeviceAttributeDto: UpdateDeviceAttributeDto,
  ): Observable<TData> {
    return this.http.patch<TData>(`/devices/v1/clients/${clientId}/device-attributes/${id}`, updateDeviceAttributeDto);
  }
  /**
   * @summary Delete a device attribute
   */

  deleteAttribute<TData = void>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
    id,
  }: DeviceAttributesControllerDeleteAttributePathParameters): Observable<TData> {
    return this.http.delete<TData>(`/devices/v1/clients/${clientId}/device-attributes/${id}`);
  }
}
